<template>
    <div class="center-box">
        <div class="searchBox">
            <a-space  class=" mr-10">
                <a-input class="keyword"  allowClear v-model:value="queryParams.searchKey"  @pressEnter="changePage"
                    placeholder="请输入关键字" />
            </a-space>
            <a-space  class=" mr-10 cf">
                <span>起止日期：</span>
                <a-range-picker v-model:value="queryTime" valueFormat="YYYY-MM-DD" @change="changeTime" />
            </a-space>
            <a-space  class=" mr-10">
                <a-select
                    ref="select"
                    v-model:value="queryParams.customerNo"
                    style="width: 240px"
                    @change="changePage"
                    >
                    <a-select-option :value="item.customerNo" v-for="item in customerList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
            </a-space>
            <a-button  type="default" @click="changePage">查询</a-button>
        </div>

        <a-table :data-source="logList" align="center" class="mt10" :pagination="paginationProp" row-key="id"  @change="refreshData">
                <a-table-column  align="center" key="name" title="设备序列号" data-index="name" />
                <a-table-column  align="center" key="shellKey" title="设备名称" data-index="shellKey" ellipsis width="200"/>
                <a-table-column  align="center" key="modelNo" title="产品名称" data-index="modelNo" />
                <a-table-column  align="center" key="algorithmTypeName" title="是否最新推送" data-index="algorithmTypeName" />
                <a-table-column  align="center" key="coreTech" title="推送区域" data-index="coreTech" />
                <a-table-column  align="center" key="latestTrainingTime" title="推送类型" data-index="latestTrainingTime" >
                  <template #default="text">
                    {{ moment(text).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="onlineTime" title="推送状态" data-index="onlineTime" >
                  <template #default="text">
                    {{ moment(text).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="labelList" title="推送时间" data-index="labelList" ellipsis width="200"/>
                <a-table-column  align="center" key="status" title="推送图片" data-index="status" >
                  <template #default="text">
                    {{ text?'正常':'停用' }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="createTime" title="推送视频" data-index="createTime" >
                  <template #default="text">
                    {{ moment(text).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
                <a-table-column  align="center" key="createTime" title="操作" data-index="createTime" >
                  <template #default="text">
                    {{ moment(text).format('YYYY-MM-DD') }}
                  </template>
                </a-table-column>
        </a-table>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick, watch, reactive } from 'vue'
import { getHttpPushLogListPageVo, getAiTypeDataDict } from '/@/api/manage'
import { getCustomerListPageVo } from '/@/api/system/customer'
import moment from 'moment'
const queryParams = ref({
  page_num: 1,
  page_size: 10,
  customer_no: '',
  task_no: '',
  model_no: '',
  push_type: '',
  status: '',
  latest_data: '',
  start_time: 0,
  end_time: 0,
  search_key: null
})
const queryTime = ref([getData(-7), getData(0)])
const logList = ref([])
const paginationProp = reactive({
  showQuickJumper: false,
  showSizeChanger: false,
  page_size: 10,
  current: 1,
  total: 0
})
const customerList = ref([])
const queryParamsCustom = ref({
  page_num: 1,
  page_size: 100,
  searchKey: null
})
const algorithmTypeOptions = ref([])
onMounted(() => {
  queryParams.value.start_time = moment(getData(-7)).valueOf()
  queryParams.value.end_time = moment(getData(0)).valueOf()
  getCustomList()
})
function changeTime (value:any) {
  if (value.length === 0) {
    queryParams.value.start_time = 0
    queryParams.value.end_time = 0
  } else {
    queryParams.value.start_time = moment(value[0]).valueOf()
    queryParams.value.end_time = moment(value[1]).valueOf()
  }
  changePage()
}
function getData (day:any) {
  const today = new Date()
  const targetday = today.getTime() + 1000 * 60 * 60 * 24 * day
  today.setTime(targetday)
  const tYear = today.getFullYear()
  let tMonth = today.getMonth()
  let tDate = today.getDate()
  tMonth = doHandMonth(tMonth + 1)
  tDate = doHandMonth(tDate)
  return tYear + '-' + tMonth + '-' + tDate
}
function doHandMonth (month:any) {
  let m = month
  if (month.toString().length === 1) {
    m = '0' + month
  }
  return m
}
function getCustomList () {
  getCustomerListPageVo(queryParamsCustom.value).then(res => {
    if (res.code === 0) {
      customerList.value = res.data.list
      queryParams.value.customer_no = customerList.value[0].customerNo
      queryParams.value.page_num = 1
      getList()
    }
  })
}
function changePage () {
  queryParams.value.page_num = 1
  getList()
}
function refreshData (page:any) {
  queryParams.value.page_num = page.current
  getList()
}
function getList () {
  getHttpPushLogListPageVo(queryParams.value).then(res => {
    if (res.code === 0) {
      logList.value = res.data.list
      paginationProp.total = res.data.pagination.total
      paginationProp.current = res.data.pagination.page
    }
  })
}
</script>

<style lang="scss" scoped>

</style>
